import React from "react";
import { Box } from "@mui/material";
import { useMyTimesheetMessagesList } from "my-timesheet/hooks";
import { OcRequestsMessagesCard } from "oc/components";

interface MyTimesheetRequest {
  _id?: string;
  description?: string;
  createdAt?: string;
  createdBy?: string;
  // Add other fields as needed
}

interface MyTimesheetShowRequestDialogMessagesProps {
  request: MyTimesheetRequest;
}

export const MyTimesheetShowRequestDialogMessages = ({
  request,
}: MyTimesheetShowRequestDialogMessagesProps) => {
  const _id = request?._id;

  const {
    data: messages,
    loading,
    refetch,
  } = useMyTimesheetMessagesList({
    request: _id,
  });

  const data = request;
  const module = "MyTimesheet";
  const disabled = false;

  const newMessageArray = messages?.length > 0 ? [...messages] : [];
  const requestDescription = request?.description || "";

  if (requestDescription) {
    const descriptionMessage = {
      _id: "description",
      request: request?._id,
      message: requestDescription,
      createdAt: request?.createdAt,
      createdBy: request?.createdBy,
    };
    newMessageArray.unshift(descriptionMessage);
  }

  return (
    <Box id="my-sheet-show-request-dialog-messages">
      <OcRequestsMessagesCard
        messages={newMessageArray || []}
        module={module}
        loading={loading}
        data={data}
        disabled={disabled}
        refetch={refetch}
        role="user"
      />
    </Box>
  );
};

export default MyTimesheetShowRequestDialogMessages;
